<section
  class="zag-bulk-edit-property-dialog"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="titleId"
  [attr.aria-describedby]="errorKey() ? descriptionId + ' ' + errorId : descriptionId"
>
  <header class="zag-bulk-edit-property-dialog__header">
    <div>
      <p class="zag-bulk-edit-property-dialog__eyebrow">{{ 'bulkEdit.inline.propertyAction' | translate }}</p>
      <h2 class="zag-bulk-edit-property-dialog__title" [id]="titleId">{{ data.section.titleKey | translate }}</h2>
      <p class="zag-bulk-edit-property-dialog__selection" [id]="descriptionId">
        {{ 'bulkEdit.inline.selectedCount' | translate: { selected: data.selectedCount, total: data.matchingCount ?? data.selectedCount } }}
      </p>
    </div>
    <button
      zagButton="basic"
      zagType="secondary"
      zagSize="sm"
      type="button"
      class="zag-bulk-edit-property-dialog__close"
      [attr.aria-label]="'common.close' | translate"
      [disabled]="isStarting()"
      (click)="close()"
    >
      <span zagIcon="close" aria-hidden="true"></span>
    </button>
  </header>

  <div class="zag-bulk-edit-property-dialog__content">
    <ng-container *ngComponentOutlet="data.section.component ?? null; injector: sectionInjector" />
    @if (errorKey(); as error) {
      <p class="zag-bulk-edit-property-dialog__error" [id]="errorId" role="alert">{{ error | translate }}</p>
    }
  </div>

  <footer class="zag-bulk-edit-property-dialog__footer">
    <button zagButton="outlined" zagType="secondary" type="button" [disabled]="isStarting()" (click)="close()">
      {{ 'bulkEdit.inline.cancel' | translate }}
    </button>
    @if (supportsClear) {
      <button zagButton="outlined" zagType="error" type="button" [disabled]="isStarting()" (click)="clearValue()">
        <span zagIcon="delete" aria-hidden="true"></span>
        {{ 'bulkEdit.inline.clearValue' | translate }}
      </button>
    }
    <button zagButton type="button" [disabled]="isStarting()" [zagLoading]="isStarting()" (click)="continue()">
      {{ 'bulkEdit.inline.continue' | translate }}
    </button>
  </footer>
</section>
